import { NgModule } from '@angular/core';
import { Routes, RouterModule, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LockedFieldsListComponent } from './locked-fields-list/locked-fields-list.component';
import { LockedFieldsComponent } from './locked-fields.component';
import { LockableFieldsResolver } from './locked-fields.resolvers';

const routes: Routes = [
  {
    path: '',
    component: LockedFieldsComponent,
    runGuardsAndResolvers: (from: ActivatedRouteSnapshot, to: ActivatedRouteSnapshot) => {
      const routerStateSnapshot = to['_routerState'] as RouterStateSnapshot;
      return routerStateSnapshot.url.endsWith('custom_fields');
    },
    resolve: {
      lockableFieldsData: LockableFieldsResolver,
    },
    children: [
      {
        path: ':type',
        component: LockedFieldsListComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LockedFieldsRoutingModule {}
